var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"opacity":"0.2","y":"0.000244141","width":"28","height":"26.7826","rx":"4","fill":"#CE3100","key":0}),React.createElement("rect",{"x":"7.75098","y":"5.8584","width":"18.9382","height":"2.36727","rx":"1.18364","transform":"rotate(45 7.75098 5.8584)","fill":"#CE3100","key":1}),React.createElement("rect",{"x":"21.1416","y":"7.53223","width":"18.9382","height":"2.36727","rx":"1.18364","transform":"rotate(135 21.1416 7.53223)","fill":"#CE3100","key":2})]);
}

Close.defaultProps = {"width":"28","height":"27","viewBox":"0 0 28 27","fill":"none"};

module.exports = Close;

Close.default = Close;
